import { supabase } from '@/integrations/supabase/client';

/**
 * As RPCs `bu_*` / `rpc_bu_*` da área de Supervisão são novas e ainda não estão
 * nos tipos gerados do Supabase — mesmo padrão usado em relatorio-midhaus.
 */
export async function callRpc<T>(name: string, args: Record<string, unknown>): Promise<T> {
  const { data, error } = await (supabase.rpc as never as (n: string, a: Record<string, unknown>) => Promise<{ data: unknown; error: unknown }>)(name, args);
  if (error) throw error;
  return data as T;
}

/**
 * Acesso PostgREST às tabelas `bu_*` (e às colunas novas como organizations.is_internal),
 * que ainda não estão nos tipos gerados. Mesmo padrão de escape do callRpc.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function buFrom(table: string): any {
  return (supabase as unknown as { from: (t: string) => unknown }).from(table);
}
